import React from 'react';

const PaymentFilterIcon: React.FC<{ fill?: string }> = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="256"
    height="92"
    viewBox="0 0 256 92"
    fill="none"
    className="absolute bottom-0 right-0"
  >
    <g filter="url(#filter0_f_33030_122774)">
      <circle cx="182.5" cy="166.5" r="122.5" fill={fill || 'currentColor'} fillOpacity="0.2" />
    </g>
    <defs>
      <filter
        id="filter0_f_33030_122774"
        x="0"
        y="-16"
        width="365"
        height="365"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="30" result="effect1_foregroundBlur_33030_122774" />
      </filter>
    </defs>
  </svg>
);

export default PaymentFilterIcon;
